import 'whatwg-fetch';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { setContext } from 'apollo-link-context';
import { lsStorageService, lsStorageServiceConstants } from 'ls-vue-common';
// eslint-disable-next-line import/no-cycle
import resolvers from './graphql/resolvers';
import typeDefs from './graphql/typeDefs';

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPH_BASE_URL;

const link = setContext((_, { headers }) => {
  const authtoken = lsStorageService.get(lsStorageServiceConstants.AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      'x-auth-token': authtoken,
      'x-ls-client': process.env.VUE_APP_NAME,
      'apollographql-client-name': process.env.VUE_APP_NAME,
      'apollographql-client-version': process.env.VUE_APP_VERSION,
    },
  };
});

// Config
const clientOptions = {
  typeDefs,
  resolvers,
  httpEndpoint,
  link,
};

// Create apollo client
export const { apolloClient } = createApolloClient(clientOptions);

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        '%cError',
        'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
        error.message
      );
    },
  });

  return apolloProvider;
}
